import { useState } from "react";
import {
  useProgram, ProgramGate, ProgramLoading, NeedAuth, ProgramShell, useProgress, ProgressBar,
  CompleteButton, Block, Paragraphs, PromptList, Mantra, AccordionItem,
} from "@/pages/programs/_gate";

const muted = "text-sm sm:text-base text-muted-foreground leading-relaxed";

function DayBody({ d }) {
  return (
    <>
      <Block label="Transmission"><Paragraphs text={d.transmission} /></Block>
      <Block label="Today's practice" accent><Paragraphs text={d.practice} className={muted} /></Block>
      <Block label="Somatic cue"><p className={muted}>{d.somatic_cue}</p></Block>
      <Block label="Journal prompts"><PromptList items={d.journal_prompts} numbered /></Block>
      <Block label="Mantra"><Mantra text={d.mantra} /></Block>
      <Block label="Carry it into the day"><p className={muted}>{d.integration}</p></Block>
      <Block label="If you slip"><p className={muted}>{d.if_you_slip}</p></Block>
    </>
  );
}

export default function FrequencyReset() {
  const { loading, data, locked, needsAuth } = useProgram("/programs/frequency-reset");
  const { done, toggle, isDone } = useProgress("frequency_reset");
  const [openDay, setOpenDay] = useState(null);

  if (needsAuth) return <NeedAuth />;
  if (loading) return <ProgramLoading />;
  if (locked) return <ProgramGate productKey="frequency_reset" priceLabel="the 7-Day Frequency Reset · $33" purchaseCta="Unlock for $33" />;
  if (!data) return <ProgramLoading />;

  const current = openDay ?? (data.days.find((d) => !isDone(d.day))?.day ?? -1);

  const complete = (day) => {
    const wasDone = isDone(day);
    toggle(day);
    if (!wasDone) setOpenDay(day < data.days.length ? day + 1 : -1);
  };

  return (
    <ProgramShell eyebrow="Program · 7 days" title={data.title}>
      <p className="text-muted-foreground max-w-2xl mb-8 leading-relaxed">
        Seven days. One frequency shift per day. Read the transmission slowly, do the practice, answer the prompts in your journal, and carry the mantra with you. Give each day about 20–30 minutes. Mark it complete when you've actually lived it — not just read it.
      </p>
      <ProgressBar done={done.length} total={data.days.length} label="days" />
      <div className="space-y-3">
        {data.days.map((d) => (
          <AccordionItem
            key={d.day}
            id={`freq-day-${d.day}`}
            number={String(d.day).padStart(2, "0")}
            eyebrow={d.theme}
            title={d.title}
            open={current === d.day}
            done={isDone(d.day)}
            onToggle={() => setOpenDay(current === d.day ? -1 : d.day)}
          >
            <DayBody d={d} />
            <CompleteButton done={isDone(d.day)} onClick={() => complete(d.day)} testId={`freq-day-${d.day}-complete`} />
          </AccordionItem>
        ))}
      </div>
    </ProgramShell>
  );
}
